import { Node, Text, Element } from 'domains/reporter/RichTextEditor/core';
import type { SlateContent } from '../types';

export const walkSlateContent =
  (
    onElement?: (node: Node) => unknown,
    onText?: (node: Node) => unknown
  ): ((content: SlateContent) => void) =>
  (content) => {
    const walkNode = (node: Node) => {
      // At a text node
      if (Text.isText(node)) return onText ? onText(node) : node;

      // At an element node
      if (Element.isElement(node) && !!onElement) onElement(node);

      // Don't loop if element node has no children
      if (node.children.length === 0) return node;

      // Walk its children
      node.children.forEach(walkNode);
    };

    // Content can either be an array or object
    if (Array.isArray(content)) {
      content.forEach(walkNode);
    } else {
      walkNode(content);
    }
  };
